import { createSlice } from '@reduxjs/toolkit'

import { fetchFilterFields } from 'common/filter/actions/fetchFilterFields'
import { parseIntegrationFields } from 'common/filter/models/AudienceFilter/adapter'

import { FilterFieldsState } from './interfaces'

export const initialState: FilterFieldsState = {
  static: null,
  custom: null,
  system: null,
  global: null,
  integration: undefined,
  fetching: false,
  error: null,
  requestId: null,
  fetched: false,
}

export const filterFieldsSlice = createSlice({
  name: 'filterFields',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilterFields.pending, (state, action) => {
        state.fetching = true
        state.error = null
        state.requestId = action.meta.requestId
      })
      .addCase(fetchFilterFields.fulfilled, (state, action) => {
        const { requestId } = action.meta

        if (state.requestId !== requestId) return

        const data = action.payload
        state.static = data?.static ?? null
        state.custom = data?.custom ?? null
        state.system = data?.system ?? null
        state.global = data?.global ?? null
        state.integration = parseIntegrationFields(data?.integration ?? {})
        state.fetching = false
        state.error = null
        state.fetched = true
      })
      .addCase(fetchFilterFields.rejected, (state, action) => {
        const { requestId } = action.meta
        if (state.requestId !== requestId) return

        state.static = null
        state.custom = null
        state.system = null
        state.global = null
        state.integration = undefined
        state.fetching = false
        state.error = action.error.message || 'Unknown error'
        state.fetched = true
      })
  },
})
